import {
  ArrowLeftRightIcon,
  BufferIcon,
  ChannelIcon,
  XIcon,
  Dialog,
  Flex,
  IconButton,
} from '@buffer-mono/popcorn'

import { BackButton } from '../../../services/_shared/components/BackButton/BackButton'

import styles from './Header.module.css'

import type { JSX } from 'react'

export function Header({
  isRefreshingConnection = false,
  onBack,
}: {
  isRefreshingConnection?: boolean
  onBack?: () => void
}): JSX.Element {
  return (
    <Dialog.Header className={styles.wrapper}>
      <div>
        {isRefreshingConnection ? undefined : (
          <BackButton onBack={onBack} variant="tertiary" size="small" />
        )}
      </div>
      <div>
        {!isRefreshingConnection && (
          <Flex gap="sm" align="center">
            <BufferIcon />
            <ArrowLeftRightIcon color="subtle" />
            <ChannelIcon type="instagram" color="branded" />
          </Flex>
        )}
      </div>
      <Dialog.Close>
        <IconButton label="Close" variant="tertiary" size="small">
          <XIcon />
        </IconButton>
      </Dialog.Close>
    </Dialog.Header>
  )
}
